import { render, staticRenderFns } from "./Templates.vue?vue&type=template&id=6feb4d4a&scoped=true"
import script from "@/views/Subjects/Templates.ts?vue&type=script&lang=ts&external"
export * from "@/views/Subjects/Templates.ts?vue&type=script&lang=ts&external"
import style0 from "@/views/Subjects/templates.scss?vue&type=style&index=0&id=6feb4d4a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6feb4d4a",
  null
  
)

export default component.exports